import React, { useState, useEffect } from "react";
import logoGame from '../../assets/logo-game.png';
import  './screenLoadingComponent.css';


const loadingTexts = ["DIBUJANDO MONTAÑAS", "PINTANDO CIELO", "CREANDO MAGIA", "CARGANDO JUGADORES"];

const ScreenLoadingComponent = () => {

    const [loadingText, setLoadingText] = useState(loadingTexts[0]);

    useEffect(() => {
        let textIndex = 0;
        const textInterval = setInterval(() => {
          textIndex = (textIndex + 1) % loadingTexts.length;
          setLoadingText(loadingTexts[textIndex]);
        }, 3000);
    
        return () => clearInterval(textInterval);
      }, []);

    return (<div className="screen">
        <img src={logoGame} alt="logo game" />
        <div className="circleSpinner">
            <div className="spinner"></div>
        </div>
        <label className="spinnerText">{loadingText}</label>
    </div>);
};

export default ScreenLoadingComponent;